// extracted by mini-css-extract-plugin
export default {"multipleActions":"MultipleActionsValues_multipleActions__yFqM5","button":"MultipleActionsValues_button__cOI9n"};